'use client';
import { CartBadge } from '@eliadmin/core/src/components/header/cart-badge';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';
import Link from '@eliadmin/core/src/components/link';

export type HeaderCartButtonProps = {
  className?: {
    root?: string;
    info?: string;
    title?: string;
    price?: string;
    badge?: string;
  };
};

export function HeaderCartButton({ className }: HeaderCartButtonProps) {
  const templateSettings = useGlobalStore((state) => state.templateSettings);
  const currency = useGlobalStore((state) => state.generalLayout.currency);
  const currencySettings = useGlobalStore((state) => state.generalLayout.currency_settings);

  const { data: cart } = useQuery({ ...useCartQueryOpts() });

  const totalPriceNoVat = cart?.items_total_without_vat ?? 0;

  return (
    <Link
      href={ROUTES.CART() ?? '#'}
      className="flex h-[58px] min-w-[105px] cursor-pointer flex-col items-center justify-center rounded-lg border border-border p-2 transition-all hover:bg-primary/5"
    >
      <div className="flex w-full items-center justify-center gap-2">
        <div className={cn('relative flex h-5 w-5 items-center justify-center gap-1')}>
          <div>{HEADER_CONFIG.headerMain.cart.icon}</div>

          <CartBadge
            className={cn(
              'h-5 w-5 bg-destructive-foreground font-light hover:bg-destructive-foreground',
              className?.badge,
            )}
            variant={HEADER_CONFIG.headerMain.cart.badgeVariant}
          />
        </div>
        {(!!templateSettings?.header?.cart_text?.enabled ||
          !!templateSettings?.realty_header?.cart_text?.enabled) && (
          <div className={cn('hidden sm:grid', 'ea-cart-button__info', className?.info)}>
            {/* <p className={cn('mb-1 leading-4', 'ea-cart-button__title', className?.title)}>
              {t('text163')}
            </p> */}
            <p
              className={cn(
                'leading-2 min-w-[40px] whitespace-nowrap  pr-2 text-end text-sm font-semibold text-muted-foreground',
                'ea-cart-button__price',
                className?.price,
              )}
            >
              {formatPrice(
                templateSettings?.product_detail?.price_without_vat_first?.enabled
                  ? totalPriceNoVat
                  : cart?.items_total || 0,
                currency,
                currencySettings,
              )}
            </p>
          </div>
        )}
      </div>
      <p className="text-xs">Košík</p>
    </Link>
  );
}
